// Hard-coded random widths for suggested filter skeletons
export const suggestedFilterChipsSkeletonWidths = [
  138, 165, 230, 96, 117, 160, 155, 142, 91, 143
];
